import { importAll } from 'utils'

let gallery = []
try {
  gallery = importAll(
    (require as any).context('./gallery', false, /\.(png|jpe?g|svg)$/)
  )
} catch (e) {
  console.log(e)
}

const data: { gallery: any; video: any } = {
  gallery,
  video: null,
}

export default data
